import { render, staticRenderFns } from "./BlockType22.vue?vue&type=template&id=c6ed52e0&scoped=true"
import script from "./BlockType22.vue?vue&type=script&lang=ts"
export * from "./BlockType22.vue?vue&type=script&lang=ts"
import style0 from "./BlockType22.vue?vue&type=style&index=0&id=c6ed52e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ed52e0",
  null
  
)

export default component.exports